import $ from 'jquery';

class HeroVideo {
    videoMinScreenWidth = 768; 

    videoUrlAttr = 'data-youtube-video-url';
    heroVideoContainerId = 'hero-video-container';

    wrapperCl = '.hero';
    containerCl = '.hero__video';
    containerVideoLoadedMd = 'hero__video--loaded';
    
    $wrapper = null; 
    $container = null; 

    player = null; 

    constructor() {
        this.$wrapper = $(this.wrapperCl);
        this.$container = $(this.containerCl);

        if($(document).width() > this.videoMinScreenWidth) {
            this.initialize(); 
        }
    }

    initialize() {
        window.onYouTubeIframeAPIReady = this.setupHeroVideo; 
        this.injectYoutubeApi();
    }

    setupHeroVideo = () => {
        const url = this.$wrapper.attr(this.videoUrlAttr);
        const location = this.parseUrl(url);
        const videoId = location.search.split('=')[1];

        this.player = new window.YT.Player(this.heroVideoContainerId, {
            videoId: videoId,
            playerVars: {
                controls: 1,
                loop: 1,
                playlist: videoId,
                modestbranding: 1,
                enablejsapi: 1,
                mute: 1, 
                showinfo: 0, 
                autoplay: 1
            },
            events: {
                'onReady': this.videoLoaded
            }
        });
    }

    videoLoaded = () => {
        this.$container.addClass(this.containerVideoLoadedMd);
    }

    async injectYoutubeApi() {
        const apiUrl = '//www.youtube.com/player_api'; 

        let tag = document.createElement('script');

        let firstScriptTag = document
            .getElementsByTagName('script')[0];
        firstScriptTag.parentNode
            .insertBefore(tag, firstScriptTag);

        tag.src = apiUrl;
    }

    parseUrl(url) {
        let a = document.createElement('a');
        a.href = url;
        return a;
    };
}

export default HeroVideo;



// WEBPACK FOOTER //
// ./components/views/hero-video.js